import React, { useState, useEffect } from 'react';
import Styles from  './styles.module.sass';
import ModalPortal from 'components/Modal';
import { useHistory } from 'react-router-dom'
import { deleteCardT1 } from 'services/T1Pagos'

import { ModalError } from 'components/Error/ErrorModal'
import { usePayCard } from 'hooks/usePayCard'
import { encodeStorage, decodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

//- funcion de modal de eliminar tarjeta
function MessageRemove(props) {
    const {
        remvoeAction,
        awaitAction
    } = props

    const elimiar = () => remvoeAction(true);
    const recapacitar = () => awaitAction(true);

    return (
        <div className="modalTarjetaNoAgregada">
            <p>¿Estas seguro que deseas eliminar esta tarjeta?</p>
            <div className="contBtnsEnterado">
                <div className="contBtns">
                    <div className="btnBlanco" onClick={recapacitar}>No</div>
                    <div className="btnBlanco" onClick={elimiar}>Si, eliminar</div>
                </div>
            </div>
        </div>
    )
}

export default function CardElegirTarjeta(props) {
    const {
        terminacion,
        nombre,
        vencimiento,
        tipoTarjeta,
        logo,
        id,
        dataCard,
        update,
        setCadrActive,
        cardActive,
        position,
        setLoading
    } = props;
    const history = useHistory();

    const [showModal, SetShowModal] = useState(false);
    const {dataPayment, successPay, errorPay} = usePayCard()
    const payCardRelation = decodeStorage('payCardRelation')
    const [cvv, setCvv] = useState()
    const [contCvv, setContCvv] = useState(false)
    const [lengthCvv, setLengthCvv] = useState(3)

    // funciones para mostrar el modal
    const removeCard = (val) => showModalRemove()
    const showModalRemove = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);

    const noRemove = () => SetShowModal(false);

    // se ejecuta si el suario le da continuar
    const [respDelete, setRespDelete] = useState()
    const siRemove = () => {
        deleteCardT1(id)
        .then(setRespDelete)
    };
    
    useEffect(()=>{
        if(respDelete){
            if(respDelete.statusCode === 200){
                SetShowModal(false)
                update()
            }else{
                SetShowModal(false)
            }
        }
    },[respDelete])


    const resetCardPay = () =>{
        setFlagActivarCard(false);
        setCvv(null)
        setContCvv(null)
        setCadrActive()
        document.querySelector(`input[name="card_${position}"]`).checked = false
        setActeiveT(0)
    }


    const [flagActivarCard, setFlagActivarCard] = useState(false);
    const [activeT, setActeiveT] = useState(0)
    useEffect(()=>{
        if(cardActive){
            if(cardActive === id){
                if(activeT === 0){
                    setFlagActivarCard(true);
                    setCadrActive()
                    setActeiveT(1)
                }
                else{
                    resetCardPay()
                }
            }else{
                resetCardPay()
            }
        }
    },[cardActive])


    const activarCard = (e) => {
        setCadrActive(id)
    }

    const handlePagar = () =>{
        if(cvv?.length >= 3 ){
            dataPayment({
                idCard: id,
                cvv: cvv,
                payCardRelation: payCardRelation,
                addCard: "" 
            })
            setLoading(true)
        }
    }

    const valueCvv = (e) => {
        let inputCvv = e.target.value.replace(/[^\d]+/g,'')

        if(inputCvv?.length === lengthCvv){
            setContCvv(true)
        }
        else{
            setContCvv(false)
        }
        setCvv(inputCvv)
    }

    useEffect(()=>{
        if(tipoTarjeta === "amex"){
            setLengthCvv(4)
        } else{
            setLengthCvv(3)
        }
    },[tipoTarjeta])


    // valida pago y si no pasa manda el error
    const [errorCode, setErrorCode ] = useState()
    const [messageResponse, setMessageResponse ] = useState()
    const [sectionActive, setSectionActive ] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);
    const handleCloseErr = () => {
        setShowModalErr(false);
        history.replace(`${BASE_PATH}${SUB_DIRECTORY}elegir-tarjeta`)
    }
    useEffect(()=>{
        if(successPay){
            encodeStorage('payCodeSuccess', successPay)
            history.push(`${BASE_PATH}${SUB_DIRECTORY}thakYouPage`);
            setLoading(false)
        }
        else if(errorPay){
            setShowModalErr(true)
            setErrorCode(errorPay)
            setMessageResponse(errorPay.message)
            setSectionActive('choiseCards')
            setLoading(false)
            resetCardPay()
        }
    },[successPay, errorPay])

    return (
        <>
            <article className={Styles?.cardElegir} id={id} >
                <div className={Styles?.typeCard}>
                    <div className={Styles?.logoCard}>
                        <input type="checkbox" name={`card_${position}`} onChange={activarCard}></input>
                        <img src={`${BASE_PATH}${SUB_DIRECTORY}${logo}`} alt="logo-card" />
                    </div>
                    <div className="cardTerminacion"> <p>****{terminacion}</p></div>
                    {/* <div className="cardNombre"> <p>{nombre}</p></div> */}
                    <div className="cardVencimiento"> <p>{vencimiento}</p></div>
                    <div className={Styles?.removeItem} onClick={removeCard}>Eliminar</div>
                </div>

                <div className="contentCardElegir">
                    <div className="dataInternal">
                        {flagActivarCard &&
                            <>
                                <div className={Styles?.cardCVV}>
                                    <input placeholder="CVV"
                                        value={cvv}
                                        minLength={lengthCvv}
                                        maxLength={lengthCvv}
                                        onChange={valueCvv}
                                    />
                                </div>
                                <div className={Styles?.cardBtnPagar}>
                                    <button onClick={handlePagar} disabled={contCvv  ? "" : "disabled"}>Pagar</button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </article>

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }

            {showModal &&
                <ModalPortal type="modalSB" onClose={handleClose} >
                    <MessageRemove remvoeAction={siRemove} awaitAction={noRemove} />
                </ModalPortal>
            }
        </>
    )
}